import AssetLoader from "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "../global-33d5eebf.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "./colors.js";
import "./sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
const animate = (ctx, animationName, animationIndex, {
  x,
  y,
  width,
  height,
  scale = 1,
  xoffset = 0,
  yoffset = 0
}) => {
  const animation = AssetLoader.getInstance().getSprite(animationName);
  const randFrame = Math.floor(animationIndex) % animation.length;
  if (randFrame < 0) {
    console.warn("randFrame < 0", animationName, animationIndex);
    return;
  }
  const aniFrame = animation[randFrame];
  const image = aniFrame.image;
  const { x: ix, y: iy, width: iwidth, height: iheight, yoffset: iyoffset = 0, xoffset: ixoffset = 0 } = aniFrame;
  ctx.drawImage(
    image,
    ix,
    iy,
    iwidth,
    iheight,
    x - Math.round(width * scale) / 2 + xoffset * scale + ixoffset,
    y - Math.round(width * scale) / 2 + yoffset * scale + iyoffset,
    width * scale,
    height * scale
  );
};
export {
  animate
};
//# sourceMappingURL=render.js.map
